import { Col, Form, Select } from "antd";
import CustomDatePicker from "common/CustomDatePicker";
import {
  GET_BUYER_ENDPOINT,
  GET_BUYING_OFFICE_ENDPOINT,
  PACKING_LINES_ENDPOINT,
  PO_MAP_NEW_ENDPOINT,
  SALES_CONTRACT_LIST,
  SUB_CONTRACT_FACTORY,
} from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import { useCallback, useEffect, useState } from "react";

const { Option } = Select;

const DailyPackingAssignmentFilterFields = () => {
  const [packingLines, setPackingLines] = useState([]);
  const [buyers, setBuyers] = useState([]);
  const [buyingOffices, setBuyingOffices] = useState([]);
  const [factories, setFactories] = useState([]);
  const [salesContracts, setSalesContracts] = useState([]);
  const [poMaps, setPoMaps] = useState([]);

  const getPackingLines = useCallback(async (name = "") => {
    const res = await getData(PACKING_LINES_ENDPOINT, false, { page: 1, per_page: 100, ...(name ? { name } : {}) });
    if (res?.status === 200 || res?.data?.code === 200) {
      setPackingLines(res?.data?.data?.data || res?.data?.data || []);
    }
  }, []);

  const getBuyers = useCallback(async (name = "") => {
    const res = await getData(GET_BUYER_ENDPOINT, false, { page: 1, per_page: 100, ...(name ? { name } : {}) });
    if (res?.status === 200 || res?.data?.code === 200) {
      setBuyers(res?.data?.data?.data || res?.data?.data || []);
    }
  }, []);

  const getBuyingOffices = useCallback(async (name = "") => {
    const res = await getData(GET_BUYING_OFFICE_ENDPOINT, false, {
      page: 1,
      per_page: 100,
      ...(name ? { name } : {}),
    });
    if (res?.status === 200 || res?.data?.code === 200) {
      setBuyingOffices(res?.data?.data?.data || res?.data?.data || []);
    }
  }, []);

  const getFactories = useCallback(async (name = "") => {
    const res = await getData(SUB_CONTRACT_FACTORY, false, { page: 1, per_page: 100, ...(name ? { name } : {}) });
    if (res?.status === 200 || res?.data?.code === 200) {
      setFactories(res?.data?.data?.data || res?.data?.data || []);
    }
  }, []);

  const getSalesContracts = useCallback(async (reference_no = "") => {
    const res = await getData(SALES_CONTRACT_LIST, false, {
      page: 1,
      per_page: 100,
      ...(reference_no ? { reference_no } : {}),
    });
    if (res?.status === 200 || res?.data?.code === 200) {
      setSalesContracts(res?.data?.data?.data || res?.data?.data || []);
    }
  }, []);

  const getPoMaps = useCallback(async (original_po = "") => {
    const res = await getData(PO_MAP_NEW_ENDPOINT, false, {
      page: 1,
      per_page: 100,
      ...(original_po ? { original_po } : {}),
    });
    if (res?.status === 200 || res?.data?.code === 200) {
      setPoMaps(res?.data?.data?.data || res?.data?.data || []);
    }
  }, []);

  useEffect(() => {
    getPackingLines();
    getBuyers();
    getBuyingOffices();
    getFactories();
    getSalesContracts();
    getPoMaps();
  }, [getPackingLines, getBuyers, getBuyingOffices, getFactories, getSalesContracts, getPoMaps]);

  return (
    <>
      <Col span={4}>
        <Form.Item label="Plan Date" name="plan_date">
          <CustomDatePicker style={{ width: "100%" }} size="small" placeholder="Select Plan Date" />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Packing Line" name="packing_line_id">
          <Select
            showSearch
            allowClear
            size="small"
            placeholder="Select Packing Line"
            filterOption={false}
            onSearch={(v) => getPackingLines(v)}
            onClear={() => getPackingLines()}
          >
            {packingLines.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Sales Contract" name="sales_contract_id">
          <Select
            showSearch
            allowClear
            size="small"
            placeholder="Select Sales Contract"
            filterOption={false}
            onSearch={(v) => getSalesContracts(v)}
            onClear={() => getSalesContracts()}
          >
            {salesContracts.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.reference_no}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Buyer" name="buyer_id">
          <Select
            showSearch
            allowClear
            size="small"
            placeholder="Select Buyer"
            filterOption={false}
            onSearch={(v) => getBuyers(v)}
            onClear={() => getBuyers()}
          >
            {buyers.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Buying Office" name="buying_office_id">
          <Select
            showSearch
            allowClear
            size="small"
            placeholder="Select Buying Office"
            filterOption={false}
            onSearch={(v) => getBuyingOffices(v)}
            onClear={() => getBuyingOffices()}
          >
            {buyingOffices.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Sub Contract Factory" name="sub_contract_factory_id">
          <Select
            showSearch
            allowClear
            size="small"
            placeholder="Select Factory"
            filterOption={false}
            onSearch={(v) => getFactories(v)}
            onClear={() => getFactories()}
          >
            {factories.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="PO" name="po_map_id">
          <Select
            showSearch
            allowClear
            size="small"
            placeholder="Select PO"
            filterOption={false}
            onSearch={(v) => getPoMaps(v)}
            onClear={() => getPoMaps()}
          >
            {poMaps.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.original_po}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default DailyPackingAssignmentFilterFields;
